(function($){

  var msCartUI = document.getElementById('msGroupsBox');
  function qtyWarning(input){
    input.style.borderColor="red"
    input.parentElement.classList.add('warning');
  }
  function qtyIsOne(input){
    input.classList.remove('warning');
    input.style.borderColor="#e5e5e5"
  }
  function checkInputQuantities() {
    var msCartUI = document.getElementById('msGroupsBox');
    if(msCartUI){
      if(msCartUI.classList.contains('quantity-error')){
        return
      }
      var ms_qty_inputs = document.querySelectorAll('.ms__cart-qty')
      if(ms_qty_inputs){
        var error = false;
        ms_qty_inputs.forEach(function(input){
          if(input.value > 1){
            qtyWarning(input)
			error = true;
          } else {
            qtyIsOne(input);
          }
        });
        if (error){
          msCartUI.classList.add('quantity-error')
        } else {
          msCartUI.classList.remove('quantity-error')
        }
      }
    }
  }
  function discountMessaging(){
    var $discountBox = $('.ms__discount-content');
    if($discountBox){
      var hasMulti = false
      $('.ms__line-price-data').each(function(i, thing){
        if(thing.value == 19900) {
          hasMulti = true;
        }
      })
      if (hasMulti){
         $discountBox.prepend("<h4>Press back button and make sure each line item has a quantity of 1 to get the best deal.</h4>")
      }
      
    }
  }
//   if (msCartUI){
//     var observer = new MutationObserver(function(mutations){
//       mutations.forEach(function(mutation){ 
//         console.log(mutation)
//         if(!$('#added')){
//           $('#msGroups').prepend("<h2 id='added'></h2>");
//         } else {
//           if($("#added").text() == ""){
//             $('#added').text("$15 OFF EACH ADDITIONAL CARVER WHEN YOU CREATE SEPARATE LINES FOR EACH WITH QUANTITY=1");
//           }
//         }
          
//         if(mutation.type == "childList"){
//           checkInputQuantities();
//         }
//       })
//       checkInputQuantities();
//     });
//     observer.observe(msCartUI, {attributes: true, childList:true, subtree:true});
//   }
  checkInputQuantities();
  discountMessaging()
})(jQuery)